function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import { X } from "lucide-react";
import React, { useEffect, useState } from "react";
export const ConversationMessageTemplates = ({ onToggle, onSelectTemplate }) => {
    const _useState = useState([]), _useState2 = _slicedToArray(_useState, 2), templates = _useState2[0], setTemplates = _useState2[1];
    const _useState3 = useState(""), _useState4 = _slicedToArray(_useState3, 2), searchText = _useState4[0], setSearchText = _useState4[1];
    useEffect(() => {
        const chatElement = document.getElementById("react-message-chat");
        if (chatElement) {
            const templateMessages = chatElement.getAttribute("data-template-messages");
            if (templateMessages) {
                try {
                    setTemplates(JSON.parse(templateMessages));
                }
                catch (error) {
                    console.error("Lỗi parse JSON:", error);
                }
            }
        }
    }, []);
    const filteredTemplates = templates.filter(template => {
        try {
            const regex = new RegExp(searchText.split("").join(".*"), "i");
            return regex.test(template.content);
        }
        catch (error) {
            return false;
        }
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: "c-template-drawer__container"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "c-template-drawer__header p-4 flex justify-between items-center border-b"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "text-lg font-semibold"
    }, "\u9001\u4FE1\u30C6\u30AD\u30B9\u30C8\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8"), /*#__PURE__*/ React.createElement("button", {
        onClick: () => onToggle(),
        className: "text-xl"
    }, /*#__PURE__*/ React.createElement(X, {
        size: "16px"
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "px-3 py-3 flex items-center gap-2 border-b"
    }, /*#__PURE__*/ React.createElement("input", {
        type: "text",
        placeholder: "Search template...",
        value: searchText,
        onChange: e => setSearchText(e.target.value),
        className: "w-full p-2 border rounded-md focus:outline-none focus:ring focus:border-blue-300"
    })), /*#__PURE__*/ React.createElement("ul", {
        className: "p-2 mb-4 overflow-y-auto max-h-[calc(100vh-80px)]"
    }, filteredTemplates.map(template => /*#__PURE__*/ React.createElement("li", {
        key: template.id,
        onClick: () => onSelectTemplate(template.content),
        className: "p-3 mb-2 bg-gray-100 rounded-lg cursor-pointer hover:bg-gray-200 active:bg-gray-300 transition-all last:mb-6"
    }, template.content))));
};
